var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 98,
    viewBox: "0 0 142 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "desktop/error"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.6,
    d: "M128.987 97.001C121.056 97.001 13.823 96.752 13.823 96.7382C13.7786 96.6264 0.21038 78.7157 17.2956 59.9899C25.7614 50.7115 9.52131 38.6909 17.2956 28.3697C30.6127 10.6902 43.7891 20.6471 54.7657 15.6747C56.7054 14.7968 58.6515 13.3845 60.5998 11.2165C61.6965 9.99731 62.8981 8.93147 64.1848 8.01089C64.3823 7.86908 64.5814 7.73074 64.7826 7.59642C65.5528 7.08166 66.3519 6.61647 67.1746 6.19797C67.7275 5.91725 68.29 5.65785 68.8638 5.4192C69.7737 5.04048 70.7087 4.71363 71.6636 4.43752C73.0199 4.04496 74.4157 3.7527 75.8395 3.55498C76.4603 3.46794 77.0866 3.39992 77.7176 3.34862C89.983 2.3554 103.786 7.94114 110.909 16.1053C112.343 17.7493 118.864 26.2553 113.724 37.9473C110.478 45.3292 124.075 52.3791 128.907 60.8091C141.191 82.2406 129.098 96.7215 128.987 97.001H128.987Z",
    fill: "#D59DFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.7243 96.7925H32.1455C32.5964 96.4193 31.833 95.572 31.0357 95.5155C30.6892 95.4896 30.2507 95.5607 29.7501 95.6633C29.6341 94.1633 28.9726 87.4202 26.4786 87.6916C23.6745 87.9953 26.4786 90.6609 27.271 92.2392C27.8586 93.408 28.4778 95.0849 28.7604 95.8765C28.5325 95.9242 28.2971 95.9718 28.0559 96.0147C27.6846 94.9024 26.3012 91.1617 24.5424 91.3798C22.4777 91.635 23.3073 93.135 24.7711 94.0252C25.8445 94.6803 27.1632 95.6108 27.7898 96.0599C27.2594 96.1447 26.7049 96.2013 26.1429 96.1883C24.7007 96.1552 23.9961 96.5688 23.7234 96.7917L23.7243 96.7925Z",
    fill: "#005E3F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M124.251 96.4868H117.716C117.365 96.1919 117.958 95.5223 118.577 95.4769C118.846 95.4569 119.186 95.5126 119.574 95.5938C119.664 94.4078 120.178 89.077 122.113 89.2915C124.289 89.5314 122.113 91.6393 121.498 92.8871C121.042 93.8111 120.562 95.1366 120.342 95.7622C120.518 95.8 120.701 95.8371 120.888 95.8715C121.177 94.9922 122.249 92.0346 123.614 92.2071C125.217 92.4093 124.573 93.5945 123.437 94.2985C122.604 94.8162 121.58 95.5518 121.094 95.9073C121.506 95.9739 121.936 96.0193 122.372 96.009C123.492 95.9829 124.037 96.3101 124.249 96.4861L124.251 96.4868Z",
    fill: "#005E3F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.25846 97H140.742C140.838 97 140.916 97.0938 140.916 97.2092V97.3297C140.916 97.4451 140.838 97.5389 140.742 97.5389H1.25846C1.1622 97.5389 1.08398 97.4451 1.08398 97.3297V97.2092C1.08398 97.0938 1.1622 97 1.25846 97Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M67.7209 53.3108L64.2746 93.997C64.2746 93.997 63.9138 96.463 65.7613 96.4679C68.7991 96.4747 80.8832 96.4679 80.8832 96.4679C80.8832 96.4679 78.5967 95.9543 78.6244 94.7993C78.657 93.438 82.6524 52.9258 82.6524 52.9258L67.7209 53.3108Z",
    fill: "#3A6EEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M82.0198 95.7467C81.4222 95.7488 69.7238 95.7681 66.7649 95.7302C65.4756 95.7144 65.2491 94.5918 65.2388 93.8658C65.2332 93.5179 65.2782 93.2601 65.2782 93.2601L65.3676 92.2027L65.5961 89.5077L65.7976 87.1262L66.0572 84.0661L66.2754 81.4832L68.7246 52.5725L83.6561 52.1875C83.6561 52.1875 81.9734 69.1419 80.7831 81.4825C80.6501 82.8575 80.5241 84.1761 80.4071 85.4068C80.369 85.8 80.333 86.1836 80.297 86.5576C80.1869 87.725 80.0858 88.7975 79.9978 89.7442C79.9515 90.2433 79.9085 90.7067 79.8704 91.1316C79.7188 92.796 79.6295 93.8589 79.6281 94.061C79.6281 94.1786 79.6378 94.2886 79.6572 94.3903C79.9023 95.6869 81.7955 95.7454 82.0198 95.7454V95.7467Z",
    fill: "#B7CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M31.459 31.1719L39.8544 64.6524L41.0039 69.2373L44.9135 84.8312H117.556L103.145 31.1719H31.459Z",
    fill: "#E7EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M31.4583 31.1719L30.2949 31.5569L43.3665 85.9958L44.9135 84.8312L31.4583 31.1719Z",
    fill: "#5B86EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M43.3652 85.9967H115.56L117.554 84.832H44.9122L43.3652 85.9967Z",
    fill: "#5B86EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M68.718 96.4844H84.3496V95.7467H68.718V96.4844Z",
    fill: "#3A6EEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M80.377 85.9961L80.2959 86.5598L65.5957 89.5085L65.7972 87.127L65.8935 85.9961H80.377Z",
    fill: "#5B86EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    opacity: 0.4,
    d: "M82.0194 95.7466C81.4218 95.7487 69.7233 95.7679 66.7645 95.7301C65.4751 95.7143 65.2487 94.5916 65.2383 93.8656L79.8693 91.1328C79.7176 92.7972 79.6283 93.8601 79.6269 94.0622C79.6269 94.1798 79.6366 94.2898 79.656 94.3916C79.9011 95.6882 81.7943 95.7466 82.0187 95.7466H82.0194Z",
    fill: "#5B86EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M31.459 31.1719H103.145L114.775 74.2973H42.2724L31.459 31.1719Z",
    fill: "#E7EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M111.394 72.4298H44.2745L41.8758 62.9437L40.9479 59.2731L40.5699 57.7765L38.1047 48.0277L37.9766 47.5204L36.6741 42.3669L36.091 40.0617L35.5938 38.0947L34.4277 33.4844H100.579L101.859 38.0947L102.406 40.0617L103.046 42.3669L107.263 57.5572V57.5578L107.621 58.8448L107.787 59.4423L110.699 69.9287L111.394 72.4298Z",
    fill: "#B7CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M101.859 38.0915H35.5938L34.4277 33.4805H100.58L101.859 38.0915Z",
    fill: "#5B86EF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M37.1643 35.5644C37.0847 35.2461 37.2793 34.9883 37.5999 34.9883C37.9205 34.9883 38.2452 35.2461 38.3249 35.5644C38.4045 35.8827 38.2099 36.1405 37.8893 36.1405C37.5687 36.1405 37.2439 35.8827 37.1643 35.5644Z",
    fill: "#FBFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M39.092 35.5644C39.0124 35.2461 39.207 34.9883 39.5276 34.9883C39.8482 34.9883 40.173 35.2461 40.2526 35.5644C40.3322 35.8827 40.1377 36.1405 39.8171 36.1405C39.4964 36.1405 39.1717 35.8827 39.092 35.5644Z",
    fill: "#FBFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M41.1702 35.5644C41.0905 35.2461 41.2851 34.9883 41.6057 34.9883C41.9263 34.9883 42.2511 35.2461 42.3307 35.5644C42.4104 35.8827 42.2158 36.1405 41.8952 36.1405C41.5746 36.1405 41.2498 35.8827 41.1702 35.5644Z",
    fill: "#FBFCFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 37537"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 7372",
    x: 45.5,
    y: 22.5,
    width: 59,
    height: 51,
    rx: 7.5,
    fill: "white",
    stroke: "#B756FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M56.9823 82.7024L58.562 74.2231L67.2346 74.3196L56.9823 82.7024Z",
    fill: "white",
    stroke: "#B756FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2",
    d: "M59.1161 72.651L68.7289 72.9283L56.9427 82.5653L59.1161 72.651Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 37562"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M88.9995 48.0005C88.9995 48.5528 88.9669 49.0975 88.905 49.6324C88.2979 54.8689 84.8007 59.2229 80.0508 61.0616C78.4836 61.6671 76.7806 62 75 62C67.2683 62 61 55.7323 61 48C61 40.2677 67.2677 34 75 34C82.7323 34 89 40.2677 89 48L88.9995 48.0005Z",
    fill: "#01A324"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M73.4956 53C72.9492 53 72.4257 52.8125 72.0391 52.4782L67.6032 48.6425C66.7989 47.9471 66.7989 46.8196 67.6032 46.1242C68.4074 45.4288 69.7113 45.4288 70.5155 46.1242L73.495 48.7006L79.4845 43.5215C80.2887 42.8262 81.5926 42.8262 82.3968 43.5215C83.2011 44.2169 83.2011 45.3444 82.3968 46.0398L77.4118 50.3503L74.9509 52.4782C74.5649 52.812 74.0408 53 73.4945 53H73.4956Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M101 19.4776V9M105.524 21.9333L116.176 10.6167",
    stroke: "#A020FF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M108.588 26.2422H118.344",
    stroke: "#A020FF",
    strokeLinecap: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.19da3a3691aeba8e340b8de09013dd29.svg";
export { ForwardRef as ReactComponent };